import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { RoutePath } from "../../../routerPaths";
import type { FormBanner } from "../recordFormErrors";

/** Page-level save error at the top of a form, with optional actions. */
export function FormErrorBanner({
  banner,
  onReload,
  onDismiss,
  isReloading,
}: {
  banner: FormBanner;
  /** "Load their changes": refetch and reset the form, discarding edits. */
  onReload?: () => void;
  /** "Keep editing": close the banner. */
  onDismiss: () => void;
  isReloading?: boolean;
}) {
  return (
    <div
      role="alert"
      className="flex flex-wrap items-start gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800"
      data-testid="crm-form-error-banner"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-red-600" />
      <p className="min-w-0 flex-1">{banner.message}</p>
      {banner.offerReload && onReload && (
        <div className="flex gap-2">
          <Button type="button" size="sm" onClick={onReload} disabled={isReloading} data-testid="crm-form-load-their-changes">
            Load their changes
          </Button>
          <Button type="button" size="sm" variant="outline" onClick={onDismiss} disabled={isReloading}>
            Keep editing
          </Button>
        </div>
      )}
      {banner.offerBackToList && (
        <Button type="button" size="sm" variant="outline" asChild>
          <Link to={RoutePath.CrmList}>Back to CRM</Link>
        </Button>
      )}
    </div>
  );
}
